module.exports = __webpack_public_path__ + "img/Feature.5aaae595.jpg";